var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-search search-wrapper", class: { open: _vm.open } },
    [
      _c(
        "w-btn-icon",
        _vm._b(
          {
            attrs: { hover: !_vm.noHover },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openSearch.apply(null, arguments)
              },
            },
          },
          "w-btn-icon",
          { size: _vm.size, hoverAction: _vm.hoverAction },
          false
        ),
        [_c("i-search")],
        1
      ),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.searchTerm,
            expression: "searchTerm",
          },
        ],
        ref: "input",
        staticClass: "form-control input-sm search-box",
        attrs: { type: "text", name: "search", placeholder: "Search" },
        domProps: { value: _vm.searchTerm },
        on: {
          keyup: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSearch.apply(null, arguments)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k(
                  $event.keyCode,
                  "escape",
                  undefined,
                  $event.key,
                  undefined
                )
              ) {
                return null
              }
              return _vm.closeSearch.apply(null, arguments)
            },
          ],
          blur: _vm.closeSearch,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.searchTerm = $event.target.value
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }